import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { Action, Getter, Mutation } from "vuex-class";

// External components
import AddressSchedulePicker from "@/components/addressSchedulePicker/addressSchedulePicker";
import PaymentMethodPicker from "@/components/paymentMethodPicker/paymentMethodPicker";
import ModalAddress from "@/components/modalAddressHome/modalAddress";

import { getWeekDayByCreationWeekDayNumber } from "@/plugins/schedules_helper";

@Component({
  components: {
    AddressSchedulePicker,
    PaymentMethodPicker,
    ModalAddress,
  },
})
export default class OnBoardingStep2 extends Vue {
  @Prop({ default: false }) isGoingToNextStep;

  @Action action_updateSubscription;

  @Getter getUser;
  @Getter getSubscription;
  @Getter getCity;
  @Getter getIsUnderMobile;

  @Mutation SPINNER;

  selectedAddress = null;
  selectedCreationWeekDay = null;
  selectedProgramSchedule = null;
  selectedPaymentMethod = null;

  isShowingAddressModal = false;

  mounted() {
    this.setInitialData();
  }

  @Watch("isGoingToNextStep")
  onIsGoingToNextStepChange() {
    if (this.isGoingToNextStep) {
      this.goToNextStep();
      this.$emit("change-is-going-to-next-step");
    }
  }

  setInitialAddress() {
    const { address_id } = this.getSubscription;
    const { addresses } = this.getUser;
    if (address_id && addresses.length) {
      this.selectedAddress = addresses.find((address) => address.id === address_id);
    } else {
      this.selectedAddress = null;
    }
  }

  setInitialPaymentMethod() {
    const { payment_way, credit_card } = this.getSubscription;
    if (payment_way === "credit_card") {
      this.selectedPaymentMethod = {
        type: payment_way,
        card: credit_card,
      };
    } else {
      this.selectedPaymentMethod = {
        type: payment_way,
        card: null,
      };
    }
  }

  setInitialData() {
    const { creation_week_day, program_schedule } = this.getSubscription;
    this.setInitialAddress();
    this.setInitialPaymentMethod();
    this.selectedCreationWeekDay = getWeekDayByCreationWeekDayNumber(creation_week_day || 1);
    this.selectedProgramSchedule = program_schedule;
  }

  validate() {
    let errors = [];
    if (!this.selectedAddress || !this.selectedAddress.id)
      errors.push("La dirección de entrega está incompleta");
    if (!this.selectedCreationWeekDay) errors.push("No hay un día de entrega seleccionado");
    if (!this.selectedProgramSchedule || !this.selectedProgramSchedule.length)
      errors.push("No hay un horario de entrega seleccionado");
    if (!this.selectedPaymentMethod || !this.selectedPaymentMethod.type)
      errors.push("No hay un método de pago seleccionado");
    if (this.selectedPaymentMethod.type === "credit_card" && !this.selectedPaymentMethod.card)
      errors.push("La información de la tarjeta de crédito está incompleta");
    return errors;
  }

  async goToNextStep() {
    const errors = this.validate();
    if (!errors.length) {
      try {
        this.SPINNER(true);
        const payload = {
          commerceId: this.getCity.id,
          subscriptionId: this.getSubscription.id,
          subscription: {
            subscription: {
              address_id: this.selectedAddress.id,
              creation_week_day: this.selectedCreationWeekDay.creation_week_day,
              program_schedule: this.selectedProgramSchedule,
              payment_way: this.selectedPaymentMethod.type,
              credit_card_id:
                this.selectedPaymentMethod.type === "credit_card"
                  ? this.selectedPaymentMethod.card.id
                  : null,
            },
          },
        };
        await this.action_updateSubscription(payload);
        this.$emit("next-step");
      } catch (error) {
        this.$swal({
          title: "Error",
          text: `Error al actualizar la suscripción. ${
            error.response && error.response.data && error.response.data.message
          }`,
        });
      }
    } else {
      this.$swal({ title: "Error", text: `La validación de los datos falló. ${errors}` });
    }
    this.SPINNER(false);
  }
}
